export const APP_FILE_INSURERES = "/insurers";
export const APP_FILE_INSURER_COMPOSER = "/insurer-composer";
export const APP_FILE_CSIO_COMPANY_COMPOSER = "/csio-company-composer";
export const APP_FILE_SUB_INSURER_COMPOSER = "/sub-insurer-composer";
export const APP_FILE_POLICY_COMMISSION_COMPOSER = "/policy-commission-composer";
export const APP_FILE_UNDERWRITER_LIST= "/underwriters";
export const APP_FILE_UNDERWRITER_COMPOSER= "/underwriter-composer";
export const APP_FILE_BROKER_CODE_COMPOSER= "/broker-code-composer";
export const APP_FILE_BROKER_CODE_LIST= "/broker-code";
export const APP_FILE_BROKER_CONTACT_LIST= "/broker-contracts";
export const APP_FILE_MANAGE_BROKER_CONTACTS= "/manage-broker-contracts";
export const APP_FILE_GROUP_PLAN_LIST= "/group-plans";
export const APP_FILE_BRANCH_OFFICE_COMPOSER= "/branch-office-composer";
export const APP_FILE_BRANCH_OFFICE_LIST= "/branch-office";
export const APP_FILE_INTERESTED_PARTY_COMPOSER= "/interested-party-composer";
export const APP_FILE_INTERESTED_PARTY_LIST= "/interested-party";
export const APP_FILE_ADDITIONAL_INTEREST_COMPOSER= "/additional-interest-composer";
export const APP_FILE_ADDITIONAL_INTEREST__LIST= "/additional-interest";
